/* eslint-disable linebreak-style */

const FLAG_DEFINITIONS = {
  indexedDbLookupCache: {
    runtimeKey: 'ff_indexeddb_lookup_cache',
    envKey: 'REACT_APP_FF_INDEXEDDB_LOOKUP_CACHE',
    defaultValue: true
  },
  ordersServerPaging: {
    runtimeKey: 'ff_orders_server_paging',
    envKey: 'REACT_APP_FF_ORDERS_SERVER_PAGING',
    defaultValue: true
  },
  ordersGraphqlRead: {
    runtimeKey: 'ff_orders_graphql_read',
    envKey: 'REACT_APP_FF_ORDERS_GRAPHQL_READ',
    defaultValue: true
  },
  lookupLabelResolver: {
    runtimeKey: 'ff_lookup_label_resolver',
    envKey: 'REACT_APP_FF_LOOKUP_LABEL_RESOLVER',
    defaultValue: true
  },
  orderLinesServerPaging: {
    runtimeKey: 'ff_order_lines_server_paging',
    envKey: 'REACT_APP_FF_ORDER_LINES_SERVER_PAGING',
    defaultValue: true
  },
  i18nMultilang: {
    runtimeKey: 'ff_i18n_multilang',
    envKey: 'REACT_APP_FF_I18N_MULTILANG',
    defaultValue: true
  }
};

const parseBoolean = (value)=>{
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on', 'da'].includes(normalized)) {
    return true;
  }
  if (['0', 'false', 'no', 'off', 'nu'].includes(normalized)) {
    return false;
  }
  return null;
};

const hasWindow = ()=> typeof window !== 'undefined';

const getRuntimeFlagsObject = ()=>{
  if (!hasWindow()) {
    return null;
  }
  return window.__LAREX_FLAGS__ || null;
};

const readRuntimeFlag = (runtimeKey)=>{
  const runtimeFlags = getRuntimeFlagsObject();
  if (runtimeFlags && Object.prototype.hasOwnProperty.call(runtimeFlags, runtimeKey)) {
    return runtimeFlags[runtimeKey];
  }
  if (!hasWindow()) {
    return null;
  }
  try {
    return window.localStorage.getItem(runtimeKey);
  } catch (error) {
    return null;
  }
};

const readEnvFlag = (envKey)=>{
  try {
    return process.env[envKey];
  } catch (error) {
    return null;
  }
};

const resolveFlag = (definition)=>{
  const runtimeValue = parseBoolean(readRuntimeFlag(definition.runtimeKey));
  if (runtimeValue !== null) {
    return runtimeValue;
  }
  const envValue = parseBoolean(readEnvFlag(definition.envKey));
  if (envValue !== null) {
    return envValue;
  }
  return definition.defaultValue;
};

export const featureFlags = Object.keys(FLAG_DEFINITIONS).reduce((accumulator, flagName)=>{
  accumulator[flagName] = resolveFlag(FLAG_DEFINITIONS[flagName]);
  return accumulator;
}, {});

export const isFeatureEnabled = (flagName)=>{
  const definition = FLAG_DEFINITIONS[flagName];
  if (!definition) {
    return false;
  }
  return Boolean(resolveFlag(definition));
};

